<div
  class="!flex !items-center !justify-between !gap-3 !p-3 !pb-0 !mb-3"
  id="buscador">
  <mat-form-field class="example-full-width" style="width: 100%">
    <mat-label>Búsqueda</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      type="text"
      placeholder=""
      [(ngModel)]="busquedaDescripcion"
      name="busquedaDescripcion"
      (keydown.enter)="onEnter($event)" />
  </mat-form-field>
  <button mat-button (click)="openDialog()">
    <mat-icon>filter_list</mat-icon>
  </button>
</div>
